<template>
    <div id="snow-container">
        <!--        <div v-for="snowflake in snowflakes" :key="snowflake.id" class="snowflake" :style="snowflake.style"></div>-->
        <div v-for="snowflake in snowflakes" :key="snowflake.id" :class="snowflake.class"
             :style="snowflake.style"></div>
    </div>
</template>

<script>
    import {christmasD} from "@api/public";

    export default {
        data() {
            return {
                snowflakes: []
            };
        },
        mounted() {
            christmasD().then(res => {
                if (res.status === 200) {
                    const numSnowflakes = 50;
                    if (res.data.christmas_decoration === 1) {
                        for (let i = 0; i < numSnowflakes; i++) {
                            this.createSnowflake(6,8);
                        }
                        // 在5秒后清除雪花
                        setTimeout(() => {
                            this.clearSnowflakes();
                        }, 10000);
                    }
                    if (res.data.christmas_decoration === 2) {
                        for (let i = 0; i < numSnowflakes; i++) {
                            this.createSnowflake(1,5);
                        }
                        // 在5秒后清除雪花
                        setTimeout(() => {
                            this.clearSnowflakes();
                        }, 10000);
                    }
                }
            })
        },
        methods: {
            createSnowflake1() {
                const snowflake = {
                    id: this.snowflakes.length,
                    top: Math.random() * window.innerHeight,
                    left: Math.random() * window.innerWidth,
                    size: Math.random() * 30 + 10,
                    rotation: Math.random() * 360,
                    animationDuration: Math.random() * 5 + 5
                };

                snowflake.style = {
                    top: `${snowflake.top}px`,
                    left: `${snowflake.left}px`,
                    width: `${snowflake.size}px`,
                    height: `${snowflake.size}px`,
                    transform: `rotate(${snowflake.rotation}deg)`,
                    animationDuration: `${snowflake.animationDuration}s`
                };

                this.snowflakes.push(snowflake);

                // Remove snowflake after animation
                /*setTimeout(() => {
                    this.removeSnowflake(snowflake.id);
                }, snowflake.animationDuration * 1000);*/
            },
            getImg(min=1,max=5) {
                let s_img = 's';
                let num = Math.floor(Math.random() * max) + min
                switch (num) {
                    case 1:
                        s_img = 's1';
                        break;
                    case 2:
                        s_img = 's2';
                        break;
                    case 3:
                        s_img = 's3';
                        break;
                    case 4:
                        s_img = 's4';
                        break;
                    default:
                        s_img = 's';
                }
                return s_img;
            },
            createSnowflake(min,max) {
                const snowflake = {
                    id: this.snowflakes.length,
                    top: Math.random() * window.innerHeight,
                    left: Math.random() * window.innerWidth,
                    size: Math.random() * 30 + 10,
                    rotation: Math.random() * 360,
                    animationDuration: Math.random() * 5 + 5,
                    // 随机选择图片类
                    // imageClass: Math.random() < 0.5 ? 's1' : 's2',
                    imageClass:this.getImg(min,max),
                };

                snowflake.style = {
                    top: `${snowflake.top}px`,
                    left: `${snowflake.left}px`,
                    width: `${snowflake.size}px`,
                    height: `${snowflake.size}px`,
                    transform: `rotate(${snowflake.rotation}deg)`,
                    animationDuration: `${snowflake.animationDuration}s`,
                };

                // 将图片类添加到雪花元素的类中
                this.snowflakes.push({...snowflake, class: `snowflake ${snowflake.imageClass}`});

                // Remove snowflake after animation
                /*setTimeout(() => {
                    this.removeSnowflake(snowflake.id);
                }, snowflake.animationDuration * 1000);*/
            },
            removeSnowflake(id) {
                this.snowflakes = this.snowflakes.filter(snowflake => snowflake.id !== id);
            },
            clearSnowflakes() {
                this.snowflakes = [];
            }
        }
    };
</script>

<style>
    #snow-container {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        pointer-events: none;
    }

    .snowflake {
        position: absolute;
        background: url('../assets/images/s.png') no-repeat center center;
        background-size: contain;
        animation: snowfall linear infinite;
        z-index: 998;
    }

    .snowflake .s {
        position: absolute;
        background: url('../assets/images/s.png') no-repeat center center;
        background-size: contain;
        animation: snowfall linear infinite;
        z-index: 998;
    }

    .snowflake.s1 {
        position: absolute;
        background: url('../assets/images/year/s1.png') no-repeat center center;
        background-size: contain;
        animation: snowfall linear infinite;
        z-index: 998;
    }

    .snowflake.s2 {
        position: absolute;
        background: url('../assets/images/year/s2.png') no-repeat center center;
        background-size: contain;
        animation: snowfall linear infinite;
        z-index: 998;
    }

    .snowflake.s3 {
        position: absolute;
        background: url('../assets/images/year/s3.png') no-repeat center center;
        background-size: contain;
        animation: snowfall linear infinite;
        z-index: 998;
    }

    .snowflake.s4 {
        position: absolute;
        background: url('../assets/images/year/s4.png') no-repeat center center;
        background-size: contain;
        animation: snowfall linear infinite;
        z-index: 998;
    }

    @keyframes snowfall {
        to {
            transform: translateY(100vh);
        }
    }
</style>
